import React from "react";
import { DEVICES } from "../../constants/literary_devices";
import Content from "./Content";
import Filters from "./Filters";
import PageDescription from "./PageDescription";
import QueryParamsControls from "./QueryParamsControls";

class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterBy: this.props.filterOptions[0],
      viewMode: DEVICES
    };
  }

  handleParamChange = (
    viewMode = this.state.viewMode,
    filterBy = this.state.filterBy,
    updateHistory = true
  ) => {
    const url = new URL(window.location);
    if (viewMode) {
      url.searchParams.set("viewMode", viewMode);
    }
    if (filterBy) {
      url.searchParams.set("filterBy", filterBy.value);
    }
    if (updateHistory) {
      window.history.pushState({}, "", url.toString());
    }
  };

  setViewMode = (value, updateHistory = true) => {
    this.setState({ viewMode: value }, () =>
      this.handleParamChange(value, undefined, updateHistory)
    );
  };

  setCurrentFilter = (option, updateHistory = true) => {
    this.setState({ filterBy: option }, () =>
      this.handleParamChange(undefined, option, updateHistory)
    );
  };

  lowerCaseOptions = this.props.filterOptions.map((option) => ({
    ...option,
    value: option.value.toLowerCase()
  }));

  render() {
    return (
      <>
        <PageDescription
          authorName={this.props.authorName}
          bookTitle={this.props.bookTitle}
        />
        <Filters
          sectionType={this.props.sectionType}
          setCurrentFilter={this.setCurrentFilter}
          currentFilter={this.state.filterBy}
          filterOptions={this.lowerCaseOptions}
          setViewMode={this.setViewMode}
          viewMode={this.state.viewMode?.toLowerCase()}
          hideFilters={this.props.hideFilters}
        />
        <Content
          hideFilters={this.props.hideFilters}
          filterOptions={this.props.filterOptions}
          filterBy={this.state.filterBy}
          summarySections={this.props.summarySections}
          viewMode={this.state.viewMode}
          litTerms={this.props.litTerms}
        />
        <QueryParamsControls
          filterOptions={this.props.filterOptions}
          setViewMode={this.setViewMode}
          setFilterBy={this.setCurrentFilter}
        />
      </>
    );
  }
}

export default LandingPage;
